import { api } from "@contexts";
import { PDFData } from "@interfaces/Document";
import {
  ErrorType,
  onDocumentSignatureAxiosErrorInterpreter,
} from "./onDocumentSignatureError";

export interface SignPrescriptionDocumentsParams {
  requestId: string;
  managementSummary: string;
  pin: string;
}

interface SignPrescriptionDocumentsResponse {
  prescriptions: PDFData[];
}

export async function signPrescriptionDocuments({
  requestId,
  managementSummary,
  pin,
}: SignPrescriptionDocumentsParams): Promise<[string, PDFData[]]> {
  const response = await api<SignPrescriptionDocumentsResponse, ErrorType>(
    {
      method: "post",
      url: `/requests/${requestId}/prescriptions/sign`,
      data: {
        managementSummary,
        pin,
      },
    },
    onDocumentSignatureAxiosErrorInterpreter
  );
  return [requestId, response.prescriptions];
}
